
import { BellOutlined } from '@ant-design/icons';
import { Atom, Dot, LayoutDashboard, Logs, Proportions, SquareUserRound } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { ROUTES, SideBarMenus } from 'routes/constants';
import { HasPermission } from 'utils/CheckPermissions';

import { ItemWithEnforcedKey } from './menu-items.types';

export const getMenuItems = (): ItemWithEnforcedKey[] => [
  HasPermission(SideBarMenus.DASHBOARD, "view") ?
    {
      key: ROUTES.DASHBOARD,
      icon: <LayoutDashboard color="#FFFFFF" size={20} />,
      label: (
        <NavLink to={ROUTES.DASHBOARD}>
          Dashboard
        </NavLink>
      ),
    } : null
  ,
  HasPermission(SideBarMenus.ADMIN, "view") ?
    {

      key: ROUTES.USERS,
      label: "User Management",
      icon: <SquareUserRound color="#FFFFFF" size={20} />,
      children: [
        HasPermission(SideBarMenus.ADMIN, "view") ?
          {
            key: ROUTES.USERS_APP,
            label: (
              <NavLink to={ROUTES.USERS_APP}>
                Admins
              </NavLink>
            ),
          } : null,
      ],
    } : null
  ,
  (HasPermission(SideBarMenus.MATERIAL, "view") ||  HasPermission(SideBarMenus.MATERIALDETAIL, "view") 
  || HasPermission(SideBarMenus.SUPPLIER, "view") || HasPermission(SideBarMenus.SUPPLIER, "view") ||  HasPermission(SideBarMenus.STATIONS, "view")  )?
    {
      key: ROUTES.MASTER,
      label: "Master",
      icon: <Atom color="#FFFFFF" size={20} />,
      children: [
        HasPermission(SideBarMenus.MATERIAL, "view") ?
          {
            key: ROUTES.MATERIAL,
            label: (
              <NavLink to={ROUTES.MATERIAL}>
                Material
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.MATERIALDETAIL, "view") ?
          {
            key: ROUTES.MATERIAL_DETAIL_LOG,
            label: (
              <NavLink to={ROUTES.MATERIAL_DETAIL_LOG}>
                Material Detail
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.SUPPLIER, "view") ?
          {
            key: ROUTES.SUPPLIER,
            label: (
              <NavLink to={ROUTES.SUPPLIER}>
                Customer / Supplier 
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.STATIONS, "view") ? {
          key: ROUTES.STATION,
          label: (
            <NavLink to={ROUTES.STATION}>
              Station
            </NavLink>
          ),
        } : null,

      ],
    } : null
  ,
  (HasPermission(SideBarMenus.TATREPORT, "view") || HasPermission(SideBarMenus.TOLERANCEREPORT, "view") || HasPermission(SideBarMenus.VEHICLEREPORT, "view") || HasPermission(SideBarMenus.SALES, "view") || HasPermission(SideBarMenus.PURCHASE, "view")) ?
    {
      key: ROUTES.REPORT,
      icon: <Proportions color='#FFFFFF' size={20} />,
      label: "Reports",
      children: [
        HasPermission(SideBarMenus.TATREPORT, "view") ?
          {
            key: ROUTES.TAT,
            icon: <Dot color="#FFFFFF" size={20} />,
            label: (
              <NavLink to={ROUTES.TAT}>
                TAT
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.TOLERANCEREPORT, "view") ?
          {
            key: ROUTES.TOLRANCE,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.TOLRANCE}>
                Tolerance
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.VEHICLEREPORT, "view") ?
          {
            key: ROUTES.VECHILE,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.VECHILE}>
                Vechicle Entry Report
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.SALES, "view") ?
          {
            key: ROUTES.SALES,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.SALES}>
                Sales
              </NavLink>
            ),
          } : null,
          HasPermission(SideBarMenus.PURCHASE, "view") ?
          {
            key: ROUTES.PURACHASE,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.PURACHASE}>
                Purchase
              </NavLink>
            ),
          }:null
      ],
    } : null,
  (HasPermission(SideBarMenus.ENTRYLOGS, "view") || HasPermission(SideBarMenus.LOADINGLOGS, "view") || HasPermission(SideBarMenus.UNLOADINGLOGS, "view") ) ?
    {
      key: ROUTES.LOG,
      label: "Log",
      icon: <Logs color="#FFFFFF" size={20} />,
      children: [
        HasPermission(SideBarMenus.ENTRYLOGS, "view") ?
          {
            key: ROUTES.LOG,
            icon: <Dot color="#FFFFFF" size={20} />,
            label: (
              <NavLink to={ROUTES.LOG}>
                Entry/Exit Log
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.LOADINGLOGS, "view") ?
          {
            key: ROUTES.LOADING_LOG,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.LOADING_LOG}>
                Loading Log
              </NavLink>
            ),
          } : null,
        HasPermission(SideBarMenus.UNLOADINGLOGS, "view") ?
          {
            key: ROUTES.UNLOADING_LOG,
            icon: <Dot color="#FFFFFF" size={20} />,

            label: (
              <NavLink to={ROUTES.UNLOADING_LOG}>
                Unloading Log
              </NavLink>
            ),
          } : null,

      ],
    } : null,
  HasPermission(SideBarMenus.WBPRIORITY, "view") ?
    {
      key: ROUTES.Setting,
      label: "Setting",
      icon: <Atom color="#FFFFFF" size={20} />,
      children: [
       HasPermission(SideBarMenus.WBPRIORITY, "view") ?
        {
          key: ROUTES.WEIGHBRIDEGE,
          icon: null,
          label: (
            <NavLink to={ROUTES.WEIGHBRIDEGE}>
              WeighBridge Priority
            </NavLink>
          )
        }:null ,
      ],
    } : null,
     HasPermission(SideBarMenus.NOTIFICATIONS, "view") ?
    {
      key: ROUTES.NOTIFICATION,
      icon: <BellOutlined style={{ fontSize: 20, color: "#FFFFFF" }} />,
      label: (
        <NavLink to={ROUTES.NOTIFICATION}>
          Notification
        </NavLink>
      ),
    } : null
];
        
